export class SubsidyReportDto {
  static setup(data) {
    return data;
  }
}
